import './App.css';
import { Routes, Route, Link } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
import React from 'react';

import Header from './Components/header';
import StickyHeader from './Components/stickyheader';
import Footer from './Components/footer';

// Home page sections
import Hero from "./Components/Home/hero";
import About from './Components/Home/about';
import About1 from './Components/Home/about1';
import Craft from './Components/Home/craft';
import Process from './Components/Home/process';
import Industri from "./Components/Home/industri";
import Technology from "./Components/Home/technology";
import Testimonial from "./Components/Home/testimonial";
import Client from './Components/Home/client';

// About Us page
import AboutUs from "./Components/About/about";
import AboutUs1 from './Components/About/about1';
import MissionVision from './Components/About/mission';
import AboutPage from './Components/About/aboutpage';

// Career page
import Career from "./Components/Career/career";

//Director Page
import Director from "./Components/Director/director";

//Our Team Page
import Team from "./Components/Team/team";

//Testimonial page
import Testimonialpage from "./Components/Testimonial/testimonial";

//Services page
import ProductBranding from "./Components/Services/Product-Branding/product-branding";
import BusinessProcessAutomation from './Components/Services/Business-Process-Automation/business-process-Automation';
import CloudComputing from './Components/Services/Cloud-Computing/cloud-computing';
import CloudServer from './Components/Services/Cloud-Server/cloud-server';
import CyberSecurity from './Components/Services/CyberSecurity/cybersecurity';
import DigitalTransformation from './Components/Services/Digital-Transformation/digital-transformation';
import DomainHosting from './Components/Services/Domain & Hosting/Domai-Hosting';
import ErpCrp from './Components/Services/ERP-CRP/Erp-Crp';
import Ecommerce from './Components/Services/Ecommerce/Ecommerce';
import EmailService from './Components/Services/Email Services/email-service';
import Graphic from './Components/Services/Graphic Design/graphic';
import ItConsulting from "./Components/Services/It Consulting And Service/it-consulting";
import ItInfra from "./Components/Services/It Infrastructure/it-infra";
import Mobile from './Components/Services/Mobile-App/mobile';
import Website from './Components/Services/Website/web';

//Technology page
import AiMl from "./Components/Technology/Ai-Ml/ai-ml";
import Flutter from "./Components/Technology/Flutter/flutter";
import Html from "./Components/Technology/Html-Css/html";
import Laravel from "./Components/Technology/Laravel-Codeigniter/laravel";
import Php from "./Components/Technology/Php-Mysql/php";
import Shopify from "./Components/Technology/Shopify/shopify";
import Woordpress from "./Components/Technology/Wordpress-Woocommerce/wordpress";

//Industires page
import Bfsi from "./Components/Industries/Bfsi Solution/bfsi";
import Doctor from "./Components/Industries/Doctors/doctor";
import EcommerceIndu from './Components/Industries/Ecommerce/ecommerce';
import Education from './Components/Industries/Education/education';
import HealthCare from './Components/Industries/Healthcare/health';
import Logistic from './Components/Industries/Logistic/logistic';
import ProductManu from './Components/Industries/Product Manufacture/productman';
import RealEstate from './Components/Industries/Real Estate/realestate';
import Sports from './Components/Industries/Sports & Gaming/sports';

//Contact Us Page
import Contact from './Components/Contact/contact';
import GetQuote from './Components/Quote/quote';

//Footer Pages
import Service from "./Components/Services/services";
import Technologys from './Components/Technology/technology';
import Industry from './Components/Industries/industries';
import Terms from "./Components/Footer/term";
import PrivacyPolicy from './Components/Footer/privacy';
import Refund from './Components/Footer/refund';

//Extra component
import WhatsAppFloating from './Components/Whatsapp/whatsapp';
import ScrollTopButton from './Components/Scroll/scrollTop';
import Refresh from './Components/Scroll/refresh';

//Odoo component
import Odoo from './Components/Odoo/odoo';

//Product component
import Product from "./Components/Product/product";
import Attendance from './Components/Product/Attendance/attendance';
import Lead from './Components/Product/Lead Management/lead';
import Sales from './Components/Product/Sales & Accounting/sales';
import Odoo1 from './Components/Product/Odoo Service/odoo1';

//Loader Component
import Loader from "./Components/Loader/loader";

//SEO Component
import SEO from "./Components/seo";

// Pages
function HomePage() {
  const pageKeywords = [
    "website development company in ahmedabad",
    "software development company in ahmedabad",
    "erp development company india",
    "crm software development",
    "odoo partner india",
    "mobile app development company ahmedabad",
    "custom software development india",
  ];
  return (
    <>
      <SEO
        title="India&#039;s #1 Website and Mobile app development company of ahmedabad"
        description="Elevate your business with Horizon Webinfo Pvt Ltd – a leading provider of bespoke web development, IT consulting, ERP, CRM, Mobile App and digital transformation solutions since 2005. Our expert team crafts innovative and scalable solutions tailored to your unique needs, ensuring you stay ahead in the competitive digital landscape."
        canonical="https://www.hwplindia.com"
        ogImage="https://www.hwplindia.com/wp-content/uploads/2020/11/erp-crm-solution-img-1.jpg"
        keywords={pageKeywords}
      />
      <Hero />
      <About />
      <About1 />
      <Craft />
      <Process />
      <Industri />
      <Technology />
      <Testimonial />
      <Client />

    </>
  );
}


function App() {
  const location = useLocation();
  const [isLoading, setIsLoading] = React.useState(true);

  const showLoader = () => {
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 400);
  };

  // Show loader on route change
  React.useEffect(() => { showLoader(); }, [location.pathname]);



  return (
    <>
      {/* Page Loader */}
      {isLoading && <Loader />}


      <Refresh />
      {/* Button appears on all pages */}
      <button className="quote-btn-main">
        <Link to="/get-a-quote">GET A QUOTE →</Link>
      </button>

      <Header className="main-header" onLinkClick={showLoader} />

      {/* Trigger element for Sticky Header */}
      <div id="sticky-trigger" style={{ height: '1px' }}>
        <StickyHeader onLinkClick={showLoader} />
      </div>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/company/about" element={<AboutPage />} />
        <Route path="/company/career" element={<Career />} />
        <Route path="/company/director" element={<Director />} />
        <Route path="/company/our-team" element={<Team />} />
        <Route path="/company/testimonial" element={<Testimonialpage />} />

        {/* Services Page */}
        <Route path="/services/product-branding" element={<ProductBranding />} />
        <Route path="/services/business-process-automation" element={<BusinessProcessAutomation />} />
        <Route path="/services/cloud-computing-services" element={<CloudComputing />} />
        <Route path="/services/cloud-server-solution" element={<CloudServer />} />
        <Route path="/services/cybersecurity-solutions-ahmedabad" element={<CyberSecurity />} />
        <Route path="/services/digital-transformation-consulting" element={<DigitalTransformation />} />
        <Route path="/services/domain-hosting" element={<DomainHosting />} />
        <Route path="/services/erp-crm-solution" element={<ErpCrp />} />
        <Route path="/services/ecommerce-development-ahmedabad" element={<Ecommerce />} />
        <Route path="/services/email-services" element={<EmailService />} />
        <Route path="/services/graphics-design" element={<Graphic />} />
        <Route path="/services/it-consulting-and-advisory" element={<ItConsulting />} />
        <Route path="/services/it-infrastructure-management" element={<ItInfra />} />
        <Route path="/services/mobile-app-development" element={<Mobile />} />
        <Route path="/services/website-development-in-ahmedabad" element={<Website />} />

        {/* Technology Page */}
        <Route path="/technology/ai-ml" element={<AiMl />} />
        <Route path="/technology/flutter" element={<Flutter />} />
        <Route path="/technology/html-css" element={<Html />} />
        <Route path="/technology/laravel-codeigniter" element={<Laravel />} />
        <Route path="/technology/php-mysql" element={<Php />} />
        <Route path="/technology/shopify" element={<Shopify />} />
        <Route path="/technology/wordpress-woocommerce" element={<Woordpress />} />

        {/* Industries Page*/}
        <Route path='/industries/bfsi-solution' element={<Bfsi />} />
        <Route path='/industries/doctors' element={<Doctor />} />
        <Route path='/industries/e-commerce' element={<EcommerceIndu />} />
        <Route path='/industries/education' element={<Education />} />
        <Route path='/industries/healthcare' element={<HealthCare />} />
        <Route path='/industries/logistics' element={<Logistic />} />
        <Route path='/industries/product-manufacturer' element={<ProductManu />} />
        <Route path='/industries/real-estate' element={<RealEstate />} />
        <Route path='/industries/sports-gaming' element={<Sports />} />

        {/*Contact Us Page*/}
        <Route path='/contact-us' element={<Contact />} />
        <Route path='/get-a-quote' element={<GetQuote />} />

        {/*Footer Pages*/}
        <Route path='/services' element={<Service />} />
        <Route path='/technology' element={<Technologys />} />
        <Route path='/industries' element={<Industry />} />
        <Route path='/terms-and-conditions' element={<Terms />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/refund' element={<Refund />} />

        {/*Odoo Page*/}
        <Route path='/odoo' element={<Odoo />} />

        {/*Product Page*/}
        <Route path='/products' element={<Product />} />
        <Route path='/products/attendance-system' element={<Attendance />} />
        <Route path='/products/lead-management' element={<Lead />} />
        <Route path='/products/sales-accounting' element={<Sales />} />
        <Route path='/products/oddo-services' element={<Odoo1 />} />


        {/* <Route path="/test" element={
          <>
            <Helmet>
              <title>Test Page | MyCompany</title>
              <meta name="description" content="This is a Helmet test page." />
            </Helmet>
          </>
        } /> */}
        <Route
          path="*"
          element={<h2 style={{ textAlign: 'center', padding: '50px' }}>404 - Page Not Found</h2>}
        />
      </Routes>
      <ScrollTopButton />
      {/* WhatsApp Floating Button */}
      <WhatsAppFloating
        phoneNumber="919898876310"
        message="Hello! Hwpl I have a question."
      />
      <Footer />

    </>
  );
}

export default App;
